import { useState } from "react";
import { useTranslation } from "@thyra/landing-i18n";
import { FAQ_IDS } from "@/src/seo/faq";
import { SectionHeader } from "./ui/SectionHeader";

export function FAQSection() {
  const { t } = useTranslation("sections");
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section
      id="faq"
      className="pt-20 sm:pt-28 pb-12 sm:pb-14 bg-background-muted"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow={t("faq.eyebrow")}
          title={t("faq.title")}
          description={t("faq.description")}
        />
        <div className="mt-12 space-y-2">
          {FAQ_IDS.map((id, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={id}
                className={`marketing-card overflow-hidden !rounded-xl ${
                  isOpen ? "!border-primary/25" : ""
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex w-full items-center justify-between px-4 py-4 text-left text-sm font-medium text-card-foreground hover:bg-muted rounded-xl transition-colors"
                >
                  {t(`faq.items.${id}.q`)}
                  <span
                    className="text-muted-foreground text-lg font-light min-w-[1.25rem] inline-flex items-center justify-center transition-transform duration-300 ease-out"
                    aria-hidden
                  >
                    <span
                      className={`inline-block transition-transform duration-300 ease-out ${
                        isOpen ? "rotate-45" : "rotate-0"
                      }`}
                    >
                      +
                    </span>
                  </span>
                </button>
                <div
                  className="grid transition-[grid-template-rows,opacity] duration-300 ease-out"
                  style={{
                    gridTemplateRows: isOpen ? "1fr" : "0fr",
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <div className="min-h-0 overflow-hidden">
                    <div className="border-t border-border px-4 py-3 text-sm text-muted-foreground">
                      {t(`faq.items.${id}.a`)}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
